document.addEventListener("DOMContentLoaded", function () {
  const masonryScript = document.createElement("script");
  masonryScript.src = "https://cdnjs.cloudflare.com/ajax/libs/masonry/4.2.2/masonry.pkgd.min.js";
  document.head.appendChild(masonryScript);

  masonryScript.onload = () => {
    const searchInput = document.querySelector(".comprehensive-field-guide__search--input");
    const defaultIcon = document.querySelector(".comprehensive-field-guide__search--default-icon");
    const activeIcon = document.querySelector(".comprehensive-field-guide__search--active-icon");
    const searchResultsText = document.querySelector(".comprehensive-field-guide__content--search-results-text");
    const fieldGuideCards = Array.from(document.querySelectorAll(".comprehensive-field-guide__card"));
    const fieldGuideContainer = document.querySelector(".comprehensive-field-guide__content--container");
    const announcementBar = document.querySelector(".shopify-section--announcement-bar");
    const sectionText = document.querySelectorAll(".comprehensive-field-guide__card--section-text");
    const noteText = document.querySelectorAll(".comprehensive-field-guide__card--note-text");
    const stratBroText = document.querySelectorAll(".comprehensive-field-guide__card--strat-bro-text");
    const header = document.querySelector(".comprehensive-field-guide__header");
    const headerHeight = announcementBar.offsetHeight + header.offsetHeight;
    let originalSearchInputPosition = searchInput.getBoundingClientRect().top + window.scrollY;

    processRichText(sectionText);
    processRichText(noteText);
    processRichText(stratBroText);
    adjustTipHeights();
    setupEventListeners();

    // Separate and sort the cards based on their data-position
    const sortedCards = [...fieldGuideCards].sort((a, b) => {
      const positionA = parseInt(a.getAttribute("data-position")) || Infinity;
      const positionB = parseInt(b.getAttribute("data-position")) || Infinity;
      return positionA - positionB;
    });

    fieldGuideContainer.innerHTML = "";

    // Append the sorted cards to the DOM
    sortedCards.forEach((card) => fieldGuideContainer.appendChild(card));

    // Initialize Masonry
    const msnry = new Masonry(fieldGuideContainer, {
      itemSelector: ".comprehensive-field-guide__card",
      columnWidth: ".comprehensive-field-guide__card",
      gutter: 30,
      originLeft: true,
      resize: true,
    });

    // Insert HTML from data-rich-text into into elements
    function processRichText(elements) {
      elements.forEach((text) => {
        const richTextJson = text.getAttribute("data-rich-text");
        if (richTextJson) {
          text.innerHTML = decodeHTMLEntities(richTextJson);
        }
      });
    }

    // Decode HTML entities
    function decodeHTMLEntities(text) {
      const textArea = document.createElement("textarea");
      textArea.innerHTML = text;
      return textArea.value;
    }

    // Adjust the height of Tip Bro containers based on text content
    function adjustTipHeights() {
      const tipBroContainers = document.querySelectorAll(".comprehensive-field-guide__card--strat-bro");
      const tipBroTexts = document.querySelectorAll(".comprehensive-field-guide__card--strat-bro-text p");

      tipBroContainers.forEach((container, index) => {
        const correspondingText = tipBroTexts[index];

        if (container && correspondingText) {
          const textHeight = correspondingText.getBoundingClientRect().height;
          const containerHeight = container.getBoundingClientRect().height;

          if (textHeight > containerHeight) {
            container.style.height = `${textHeight + 8}px`;
          }
        }
      });
    }

    // Register event listeners for search input and clear button
    function setupEventListeners() {
      activeIcon.addEventListener("click", clearSearch);
      searchInput.addEventListener("input", handleSearchInput);
    }

    // Clear the search input and reset the layout
    function clearSearch() {
      searchInput.value = "";
      toggleIcons(false);
      searchResultsText.classList.add("hidden-animated");
      searchResultsText.textContent = "";
      searchInput.focus();

      fieldGuideCards.forEach((card) => {
        if (!fieldGuideContainer.contains(card)) {
          fieldGuideContainer.appendChild(card);
        }
      });

      msnry.layout();
    }

    // Handle the search input event, filter cards, and update the UI
    function handleSearchInput() {
      const query = searchInput.value.toLowerCase();
      const currentScrollPosition = window.scrollY;

      if (currentScrollPosition > originalSearchInputPosition) {
        window.scrollTo({ top: headerHeight, behavior: "smooth" });

        setTimeout(() => {
          toggleIcons(query.length > 0);
          searchCards(query);
        }, 100);
      } else {
        toggleIcons(query.length > 0);
        searchCards(query);
      }
    }

    // Toggle search and clear icons based on whether user is searching
    function toggleIcons(isSearching) {
      defaultIcon.classList.toggle("hidden", isSearching);
      activeIcon.classList.toggle("hidden", !isSearching);
    }

    // Filter cards based on the search query and update the search results text
    function searchCards(query) {
      const filteredCards = fieldGuideCards.filter((card) => {
        const cardTitle = card.querySelector(".comprehensive-field-guide__card--header-title").textContent.toLowerCase();
        const matchesQuery = cardTitle.includes(query);

        if (matchesQuery && !fieldGuideContainer.contains(card)) {
          fieldGuideContainer.appendChild(card);
        } else if (!matchesQuery && fieldGuideContainer.contains(card)) {
          fieldGuideContainer.removeChild(card);
        }

        return matchesQuery;
      });

      if (query) {
        const resultText = filteredCards.length === 0 ? "No" : filteredCards.length;
        const resultWord = filteredCards.length === 1 ? "result" : "results";
        searchResultsText.textContent = `${resultText} ${resultWord} found for "${searchInput.value}"`;
        searchResultsText.classList.remove("hidden-animated");
      } else {
        searchResultsText.textContent = "";
        searchResultsText.classList.add("hidden-animated");
      }

      msnry.layout();
    }
  };
});
